import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';

import Table from '../../components/Table/Table';

import { numberFormat } from '../../helper/MaskHelper';

export class DadosGestaoEdicao extends Component {
    render () {
        const columns = [
            { label: 'Edição', name: 'edicao', func: null, key: true, width: '25', orderLabel: 'desc', },
            { label: 'Escolas Participantes', name: 'escolasInscritas', func: numberFormat, key: false, width: '25', },
            { label: 'Alunos Previstos', name: 'alunosPrevistos', func: numberFormat, key: false, width: '25', },
            { label: 'Municípios Participantes', name: 'municipiosInscritos', func: numberFormat, key: false, width: '25', },
        ];
        
        return (
            <Grid container spacing={3} style={{ marginTop: this.props.marginTop ?? 8 }}>
                <Grid item xs={12}>
                    <Table              
                        columns={columns}
                        tableData={this.props.edicoes}
                        actions={[]}
                        page={null}
                        rowsPerPage={null}
                        sort={null}
                    />
                </Grid>
            </Grid>
        )
    }
}

export default DadosGestaoEdicao;